import { ComponentPropsWithoutRef } from 'react';
import { twMerge } from 'tailwind-merge';

const SettingsCard = (props: ComponentPropsWithoutRef<'div'>) => {
    const { className = '', ...rest } = props;

    return <div className={twMerge('grid grid-cols-12 gap-4', className)} {...rest} />;
};

const SettingsCardLeftSide = (props: ComponentPropsWithoutRef<'div'>) => {
    const { className = '', ...rest } = props;

    return <div className={twMerge('col-span-full md:col-span-4', className)} {...rest} />;
};

const SettingsCardRightSide = (props: ComponentPropsWithoutRef<'div'>) => {
    const { className = '', ...rest } = props;

    return (
        <div
            className={twMerge('col-span-full md:col-span-8 md:col-start-6', className)}
            {...rest}
        />
    );
};

const SettingsCardHeading = (props: ComponentPropsWithoutRef<'p'>) => {
    const { className = '', ...rest } = props;

    return <div className={twMerge('text-lg font-medium', className)} {...rest} />;
};

const Root = SettingsCard;
const LeftSide = SettingsCardLeftSide;
const RightSide = SettingsCardRightSide;
const Heading = SettingsCardHeading;

export {
    SettingsCard,
    SettingsCardLeftSide,
    SettingsCardRightSide,
    SettingsCardHeading,
    //
    Root,
    LeftSide,
    RightSide,
    Heading,
};
